/** Platform admin: Usage & AI costs screen (P9, mockups/admin/usage.html). fil mirrors every key. */
export const usage = {
  title: "Usage & AI costs",
  subtitle: "What every message costs us across LLMs, embeddings and reranking. USD at provider rates, PHP at {{fx}} per USD.",
  range: {
    label: "Date range",
    mtd: "Month to date",
    d7: "Last 7 days",
    d30: "Last 30 days",
    d90: "Last 90 days",
    span: "{{from}} – {{to}}",
  },
  export: "Export",
  exported: "Usage exported as CSV",
  modelRouting: "Model routing",
  kpi: {
    messages: "Messages",
    messagesFoot: "{{conversations}} conversations · {{perConv}} msgs/conv",
    tokens: "Tokens in / out",
    tokensFoot: "avg {{in}} in · {{out}} out per msg",
    embedding: "Embedding tokens",
    embeddingFoot: "{{ingest}} ingestion · {{query}} queries",
    rerank: "Rerank calls",
    rerankFoot: "{{cost}} rerank cost",
    llmCost: "LLM cost",
    llmCostFoot: "≈ {{php}} · embeddings {{embed}}",
    perConversation: "Cost per conversation",
    perConversationFoot: "AI cost {{php}} in range",
    cache: "Semantic cache hit rate",
    cacheFoot: "{{hits}} hits · saved {{saved}}",
    margin: "Gross margin (AI)",
    marginFoot: "on revenue in range",
  },
  providers: {
    title: "Cost by provider per day",
    subtitle: "USD · {{range}}",
    chart: "AI cost per day by provider",
    share: "{{share}} share",
    emptyTitle: "No AI spend in this range",
    emptyBody: "Costs appear here as soon as tenants' agents answer messages.",
  },
  models: {
    title: "By model",
    manage: "Manage providers",
    colModel: "Model",
    colProvider: "Provider",
    colRequests: "Requests",
    colTokensIn: "Tokens in",
    colTokensOut: "Tokens out",
    colP50: "p50",
    colP95: "p95",
    colCost: "Cost",
    colShare: "Share",
    seconds: "{{value}} s",
    emptyTitle: "No model traffic in this range",
    emptyBody: "Requests per model show up once agents start answering.",
  },
  tenants: {
    title: "Top tenants by AI cost",
    subtitle: "{{range}} · revenue = subscription + add-ons",
    negativeOnly: "Negative margin only",
    colTenant: "Tenant",
    colCost: "AI cost",
    colRevenue: "Revenue",
    colMargin: "Margin",
    negative: "Negative",
    reviewOverrides: "Review overrides",
    emptyTitle: "No tenants match",
    emptyNegative: "No tenant is running at a negative margin. Nice.",
    emptyBody: "Tenants appear here once they generate AI cost.",
    showAll: "Show all tenants",
  },
  budget: {
    title: "Budget alerts",
    enabled: "Budget alerts enabled",
    spend: "Spend this month",
    spendValue: "{{spend}} / {{budget}}",
    used: "{{pct}} used this month",
    threshold: "Alert at {{pct}}",
    monthly: "Monthly budget (USD)",
    monthlyHint: "≈ {{php}} per month",
    alertAt: "Alert at",
    notify: "Notify",
    notifyHint: "Comma-separated email addresses (up to 20).",
    notifyInvalid: "Enter valid email addresses separated by commas.",
    amountInvalid: "Enter an amount between 0 and 10,000,000.",
    autoRoute: "Auto-route Starter tenants to the cheapest chat model when the budget hits 100%",
    save: "Save budget",
    saved: "Budget settings saved",
  },
  ingestion: {
    title: "Embeddings & ingestion volume",
    queue: "Queue status",
    embedIngest: "Embedding tokens (ingestion)",
    embedQuery: "Embedding tokens (queries)",
    embedCost: "Embedding cost",
    rerankCost: "Rerank cost",
    note: "File, page and OCR volumes aren't reported by the usage API yet.",
  },
} as const;
